import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    // Otherwise the next user on this browser inherits a site they may not
    // have access to at all.
    localStorage.removeItem('locationId');
    navigate('/login');
  }, []);

  return null;
};

export default Logout;